// App.js
import React from 'react';
import AppRoutes from './routes/AppRoutes';
import '../src/assets/styles/styles.css';

function App() {
  return <AppRoutes />;
}

export default App;
